import React from "react";

/**
 * ProfileMilestoneBadges — small flex row of "🌱 / ✨ / 🎉 / 🚀" loop-
 * threshold badges. Aggregates each video's `milestones_fired` and
 * groups by threshold; the parent supplies the pre-aggregated array.
 *
 * Props:
 *   badges — array of { threshold: number, count: number } | undefined.
 *            Component renders null when missing/empty.
 */
export const ProfileMilestoneBadges = ({ badges }) => {
  if (!Array.isArray(badges) || badges.length === 0) return null;
  return (
    <div data-testid="profile-milestone-badges" className="flex flex-wrap gap-1.5 items-center">
      {badges.slice(0, 4).map((b) => {
        const prefix =
          b.threshold >= 10000 ? "🚀"
          : b.threshold >= 1000 ? "🎉"
          : b.threshold >= 100 ? "✨"
          : "🌱";
        const label = b.threshold >= 1000 ? `${b.threshold / 1000}K` : `${b.threshold}`;
        return (
          <span
            key={b.threshold}
            data-testid={`profile-milestone-badge-${b.threshold}`}
            title={`${b.count} video${b.count === 1 ? "" : "s"} crossed ${b.threshold.toLocaleString()} loops`}
            className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-amber-500/15 border border-amber-500/40 text-amber-200"
          >
            <span aria-hidden="true">{prefix}</span>
            {label} loops
            {b.count > 1 && <span className="opacity-70 ml-0.5">×{b.count}</span>}
          </span>
        );
      })}
    </div>
  );
};
